import React from "react";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import Box from "@material-ui/core/Box";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { setDisplayTermsPopup } from "../../../state/slices/user";
import { useFeatureFlag } from "../../../hooks/useFeatureFlags";

const Copyright = () => {
  const dispatch = useDispatch()
  const currentUser = useSelector((state) => state.user, shallowEqual);
  const isTermsEnabled = useFeatureFlag('Features.Terms and Conditions');

  const handleTermsDialog = () => {
    dispatch(setDisplayTermsPopup(true))
  }
  
  return (
    <Box>
      <Box>
        <Typography variant="body2" color="textSecondary" align="right">
          Amano ONE
          <Typography
            style={{ paddingLeft: 6, paddingRight: 6 }}
            variant="body2"
            component="span"
            color="primary"
          >
            |
          </Typography>
          Copyright{" © "} {new Date().getFullYear()}
          <Typography
            style={{ paddingLeft: 6, paddingRight: 6 }}
            variant="body2"
            component="span"
            color="primary"
          >
            |
          </Typography>
          <Link
            color="inherit"
            target="_blank"
            href="https://www.amanomcgann.com/"
          >
            Amano McGann, Inc.
          </Link>
          {currentUser?.UserID && isTermsEnabled &&
          <>
            <Typography
              style={{ paddingLeft: 6, paddingRight: 6 }}
              variant="body2"
              component="span"
              color="primary"
            >
              |
            </Typography>
            <Link
              variant="body2"
              component="button"
              type="button"
              color={currentUser?.hasAcceptedTerms ? "inherit" : "error"}
              onClick={handleTermsDialog}
            >
              Terms and Conditions
            </Link>
          </>
          }
        </Typography>
      </Box>
    </Box>
  );
};

export default Copyright;
